<template>
  <div class="animated fadeIn">
    <b-card class="mt-5 mx-auto text-center" style="max-width: 22rem">
      <template v-if="!done">
        <h1>Activate device</h1>
        <p>
          Enter the four-character code generated by your device on the Nanome
          App login page.
        </p>
        <b-form @submit.prevent="submit">
          <b-form-row>
            <b-col v-for="i in 4" :key="`code-${i}`">
              <b-input
                v-model="code[i - 1]"
                ref="codes"
                :autofocus="i === 1"
                :formatter="codeFormat"
                aria-label="Code"
                autocomplete="off"
                class="mb-2 font-4xl text-center"
                @input="onInput(i - 1)"
                @keydown="onKeydown($event, i - 1)"
              />
            </b-col>
          </b-form-row>

          <div class="mt-2 text-danger text-center" v-if="error">
            {{ error }}
          </div>
        </b-form>
      </template>

      <template v-else>
        <h1>Device activated</h1>
        <div>Redirecting to Dashboard...</div>
      </template>
    </b-card>
  </div>
</template>

<script>
import API from "@/api";

export default {
  data: () => ({
    code: ["", "", "", ""],
    done: false,
    error: false
  }),

  methods: {
    codeFormat(code) {
      return code
        .replace(/[^A-Za-z0-9]/g, "")
        .slice(-1)
        .toUpperCase();
    },

    onInput(i) {
      if (this.code[i].length === 1 && i < 3) {
        this.$refs.codes[i + 1].focus();
      } else if (this.code[i].length === 0 && i > 0) {
        this.$refs.codes[i - 1].focus();
      } else if (this.code[i].length === 1 && i === 3) {
        this.submit();
      }
    },

    onKeydown(e, i) {
      if (e.key === "Backspace" && this.code[i].length === 0 && i > 0) {
        this.$refs.codes[i - 1].focus();
      }
    },

    async submit() {
      const res = await API.easyAuth(this.code.join(""));
      if (!res.success) {
        this.error = res.error.message;
        return;
      }

      this.done = true;
      setTimeout(() => this.$router.push("/"), 2000);
    }
  }
};
</script>
